module.exports = __webpack_public_path__ + "media/images/icons/camera-37ee6f05657994cf701d6455ab27f726.svg";